import React from 'react';
import { isTestStripePk, STRIPE_PUBLISHABLE_KEY } from '../lib/env';

const TestKeyBanner: React.FC = () => {
  const stripePublishableKey = STRIPE_PUBLISHABLE_KEY;
  const isTestKey = isTestStripePk(stripePublishableKey);
  const isProductionDomain =
    window.location.hostname.includes('autotaxpilot') &&
    !window.location.hostname.includes('localhost') &&
    !window.location.hostname.includes('127.0.0.1');

  // Only show if using test key on production domain
  if (!isTestKey || !isProductionDomain) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-red-600 text-white text-center py-2 px-4 text-sm font-medium">
      ⚠️ Stripe TEST key detected on production domain! This may cause payment failures.
    </div>
  );
};

export default TestKeyBanner;
